import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const locationSelector = (state: State) => state.location.location;
export const totalSelector = (state: State) => state.location.total;
export const noMoreSelector = (state: State) => state.location.noMore;
export const pageSelector = (state: State) => state.location.page;
export const errorCodeSelector = (state: State) => state.location.errorCode;

const locationsIdsSelector = (state: State) => state.location.locations.ids;
const locationsEntitiesSelector = (state: State) =>
  state.location.locations.entities;

export const locationsSelector = createSelector(
  [locationsIdsSelector, locationsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);
